module.exports = __webpack_public_path__ + "img/22.f5c11b2b.svg";